import React from 'react';
import PropTypes from 'prop-types';
import FormTemplate from '../../../dialogs_common/SetupTemplate';
import DevelopIdeaChoice from '../redirect/DevelopIdeaChoice';
import GetInspiredChoice from '../redirect/GetInspiredChoice';
import ExplorePotentialPartnersChoice from '../redirect/ExplorePotentialPartnersChoice';

Form.propTypes = {
  user: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func,
  onSkip: PropTypes.func
};

export default function Form(props) {
  const {
    user,
    navigation,
    onNext,
    onPrevious,
    onSkip
  } = props;

  return (
    <div className="my-auto">
      <FormTemplate
        className="w-full"
        onPrevious={onPrevious}
        navigation={navigation}
        title="Let's bring your ideas to life. How do you want to start?"
        body={(
          <div className="flex flex-col space-x-0 space-y-6">
            <DevelopIdeaChoice />
            <ExplorePotentialPartnersChoice />
            <GetInspiredChoice />
          </div>
        )}
        footer={(
          <>
            {/*<div className="text-cs-orange-500 underline cursor-pointer mt-6 sm:mt-0 mr-0 sm:mr-12" onClick={onSkip}>*/}
            {/*  No, I'm here for another reason.*/}
            {/*</div>*/}
            {/*<PrimaryButton disabled={hasError} onClick={() => hasError ? setShowErrors(true) : onSubmit()}>*/}
            {/*  Yes, that's me!*/}
            {/*</PrimaryButton>*/}
          </>
        )}
      />
    </div>
  );
};
